import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import AdminCampaignDetails from "@/views/admin/AdminCampaignDetails.vue";
import AdminCampaignOverview from "@/views/admin/AdminCampaignOverview.vue";
import ChallengeDetails from "@/views/ChallengeDetails.vue";
import GenericCampaignDetails from "@/views/GenericCampaignDetails.vue";
import GenericCampaignOverview from "@/views/GenericCampaignOverview.vue";
import TheDailyChallengeOverview from "@/views/TheDailyChallengeOverview.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/daily-challenge",
  },
  {
    path: "/daily-challenge",
    name: "daily-challenge",
    component: TheDailyChallengeOverview,
  },
  {
    path: "/challenge/:id",
    name: "challenge",
    component: ChallengeDetails,
  },
  {
    path: "/campaigns",
    name: "campaigns",
    component: GenericCampaignOverview,
  },
  {
    path: "/campaign/:id",
    name: "campaign",
    component: GenericCampaignDetails,
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminCampaignOverview,
  },
  {
    path: "/admin/campaign/:id",
    name: "campaign-admin",
    component: AdminCampaignDetails,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
